import HubspotForm from "react-hubspot-form";
import "../css/block-form.css";
import bg from "../img/bg-form.webp";
import { motion } from "framer-motion";
import img from "../img/fondo.png";



function Banner() {
  return (
    <div className="section-blockform"    style={{ backgroundImage: `url(${img})` }}>
      <motion.div
        initial={{ y: 200, opacity: 0 }}
        whileInView={{
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 200,
          },
        }}
      >
        <div className="wrapper-blockform  ">
          <div className="layout8 ">
            <div className="maxwidth">
              <h2>
                {" "}
                Reconocemos tu experiencia y conocimientos adquiridos en el
                campo laboral 💻🎓
              </h2>
                  <p>Carreras <b>tecnológicas</b> </p>
              <p>
                Valida tus competencias y <b> acredita asignaturas</b> de forma
                 ágil para avanzar en tu trayectoria académica, optimizar tu
                carga y <b>reducir tu tiempo de graduación 🎓</b>
              </p>
              <br></br> <br></br>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default Banner;
